var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserGen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0001 0.666992C6.63608 0.666992 0.666748 6.63633 0.666748 14.0003C0.666748 21.3643 6.63608 27.3337 14.0001 27.3337C21.3641 27.3337 27.3334 21.3643 27.3334 14.0003C27.3334 6.63633 21.3641 0.666992 14.0001 0.666992ZM9.33342 10.667C9.33342 10.0542 9.45412 9.44732 9.68864 8.88114C9.92317 8.31495 10.2669 7.8005 10.7003 7.36716C11.1336 6.93382 11.648 6.59008 12.2142 6.35555C12.7804 6.12103 13.3872 6.00033 14.0001 6.00033C14.6129 6.00033 15.2198 6.12103 15.7859 6.35555C16.3521 6.59008 16.8666 6.93382 17.2999 7.36716C17.7333 7.8005 18.077 8.31495 18.3115 8.88114C18.546 9.44732 18.6667 10.0542 18.6667 10.667C18.6667 11.9047 18.1751 13.0917 17.2999 13.9668C16.4247 14.842 15.2378 15.3337 14.0001 15.3337C12.7624 15.3337 11.5754 14.842 10.7003 13.9668C9.82508 13.0917 9.33342 11.9047 9.33342 10.667ZM22.3441 20.6457C21.346 21.9012 20.0772 22.9149 18.6323 23.6113C17.1875 24.3076 15.604 24.6685 14.0001 24.667C12.3962 24.6685 10.8127 24.3076 9.36786 23.6113C7.92301 22.9149 6.65417 21.9012 5.65608 20.6457C7.81742 19.095 10.7667 18.0003 14.0001 18.0003C17.2334 18.0003 20.1827 19.095 22.3441 20.6457Z",
    fill: "#314450"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserGen);
export default __webpack_public_path__ + "static/media/Ic_User_Gen.270c82c462f5fd33ebd5ba33d8842755.svg";
export { ForwardRef as ReactComponent };